import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNintendoComponent } from './simple-icons-nintendo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNintendoComponent ],
    exports:      [ SimpleIconsNintendoComponent ],
    bootstrap:    []
})
export class SimpleIconsNintendoModule {}
